/**
 * Prev Top
 */
const prevTop = () => {

  // const target = document.querySelector('.js-prevTop'),
  const target = document.querySelector('.js-prevTop');
  // height = 500;
  const height = document.documentElement.clientHeight;
  // alert(height)

  let offset = 0,
  lastPosition = 0,
  ticking = false;

  function onScroll() {
    if (lastPosition > height) {
      if (lastPosition > offset) {
        // target.classList.add('c-prevTop--scrollUp');
        target.classList.remove('c-prevTop--scrollUp');
      } else {
        // target.classList.remove('c-prevTop--scrollUp');
        target.classList.add('c-prevTop--scrollUp');
      }
      offset = lastPosition;
    } else {
      target.classList.remove('c-prevTop--scrollUp');
    }
  }

  window.addEventListener('scroll', (e) => {
    lastPosition = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(() => {
        onScroll(lastPosition);
        ticking = false;
      });
      ticking = true;
    }
  });

}

export { prevTop };
